import React from 'react';
import styled from 'styled-components/macro';
import StyledDimensionValue from '../../styles/StyledDimensionValue';

interface Props {
  feetsHeight: number;
}

const FeetsSchemaDimensions = ({ feetsHeight }: Props) => {
  return (
    <StyledCrossPieceSchema>
      <StyledDimensionValue>{feetsHeight / 10}</StyledDimensionValue>
    </StyledCrossPieceSchema>
  );
};

const StyledCrossPieceSchema = styled.div`
  grid-row-end: span 1;
  display: grid;
  justify-content: right;
  align-items: center;
`;

export default FeetsSchemaDimensions;
